import { render, staticRenderFns } from "./OptionForm.vue?vue&type=template&id=c6c47b04&scoped=true&"
import script from "./OptionForm.vue?vue&type=script&lang=js&"
export * from "./OptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c47b04",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c47b04')) {
      api.createRecord('c6c47b04', component.options)
    } else {
      api.reload('c6c47b04', component.options)
    }
    module.hot.accept("./OptionForm.vue?vue&type=template&id=c6c47b04&scoped=true&", function () {
      api.rerender('c6c47b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Option/OptionForm.vue"
export default component.exports